<template>
  <div class="d-flex flex-column">
    <span :class="`text-${text}`" class="text-xl font-weight-bold"
      >E-Mail-Adresse:</span
    >
    <div>
      <input type="email" v-model="email" class="email" required />
      <SquareButton @click.native="select">-></SquareButton>
    </div>
    <div v-if="hasErrors" class="row">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <span
            v-for="(error, index) in errors.errors.email"
            :key="index"
            v-html="error"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
input {
  height: 60px;
  border-radius: 10px;
  border: 1px solid black;

  padding: 8px;

  margin-right: 8px;
}
</style>

<script>
import SquareButton from "./SquareButton.vue";

export default {
  props: {
    errors: {
      type: Object,
      default: null
    },
    text: {
      type: String,
      default: "white"
    }
  },
  components: {
    SquareButton
  },
  data() {
    return {
      email: null
    };
  },
  computed: {
    hasErrors() {
      return this.errors !== null;
    }
  },
  methods: {
    select() {
      this.$emit("input", this.email);
    }
  }
};
</script>
